import React, { useState, useEffect, useContext } from "react";
import qs from 'query-string'

import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";
import toastUtils from "../../utils/toastUtils";
import { Formik, Form, Field } from "formik";

import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import usePlans from '../../hooks/usePlans';
import { i18n } from "../../translate/i18n";
import { FormControl } from "@material-ui/core";
import { MenuItem, Select } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { SUPPORTED_COUNTRIES, getCountryByCode } from "../../utils/countryList";
import IconButton from "@material-ui/core/IconButton";
import Brightness4Icon from "@material-ui/icons/Brightness4";
import Brightness7Icon from "@material-ui/icons/Brightness7";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import InputAdornment from "@material-ui/core/InputAdornment";
import { Helmet } from "react-helmet";

import { openApi } from "../../services/api";
import toastError from "../../errors/toastError";
import useSettings from "../../hooks/useSettings";
import ColorModeContext from "../../layout/themeContext";
import clsx from "clsx";
import { getBackendUrl } from "../../config";

const useStyles = makeStyles((theme) => ({
    // Mobile-first: Root da página (IGUAL AO LOGIN)
    root: {
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "0",
        margin: "0",
        boxSizing: "border-box",
        overflow: "hidden",
        backgroundColor: theme.palette.type === "light" ? "#f5f5f5" : "#121212",
        background: theme.palette.type === "light"
            ? "linear-gradient(135deg, #1e3a8a 0%, #3b82f6 50%, #60a5fa 100%)"
            : "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%)",
        position: "relative",
        transition: "all 0.3s ease",

        // Padrão de pontos no fundo
        "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundImage: theme.palette.type === "light"
                ? `radial-gradient(circle at 25% 25%, rgba(255,255,255,0.05) 1px, transparent 1px),
                   radial-gradient(circle at 75% 75%, rgba(255,255,255,0.05) 1px, transparent 1px)`
                : `radial-gradient(circle at 25% 25%, rgba(255,255,255,0.02) 1px, transparent 1px),
                   radial-gradient(circle at 75% 75%, rgba(255,255,255,0.02) 1px, transparent 1px)`,
            backgroundSize: "50px 50px",
            animation: "$float 20s ease-in-out infinite",
        },
    },

    "@keyframes float": {
        "0%, 100%": { transform: "translateY(0px) rotate(0deg)" },
        "50%": { transform: "translateY(-10px) rotate(180deg)" },
    },

    // Container - responsivo (BEM COMPACTO)
    containerSignup: {
        padding: "16px",
        maxWidth: "500px", // BEM COMPACTO - igual ao login
        width: "100%",
        position: "relative",
        zIndex: 10,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",

        [theme.breakpoints.down("sm")]: {
            maxWidth: "440px", // Mobile
        },
    },

    // Card do formulário (OTIMIZADO SEM SCROLL)
    paper: {
        backgroundColor: theme.palette.type === "light"
            ? "rgba(255, 255, 255, 0.95)"
            : "rgba(18, 18, 18, 0.95)",
        backdropFilter: "blur(20px)",
        WebkitBackdropFilter: "blur(20px)",
        boxShadow: theme.palette.type === "light"
            ? `0 20px 40px rgba(0, 0, 0, 0.1),
               0 1px 0 rgba(255, 255, 255, 0.2) inset,
               0 0 0 1px rgba(255, 255, 255, 0.1)`
            : `0 20px 40px rgba(0, 0, 0, 0.3),
               0 1px 0 rgba(255, 255, 255, 0.05) inset,
               0 0 0 1px rgba(255, 255, 255, 0.05)`,
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        padding: "32px 36px 28px 36px",
        borderRadius: "20px",
        maxWidth: "440px",
        width: "100%",
        margin: "0 auto",
        maxHeight: "95vh",
        overflowY: "auto",
        border: theme.palette.type === "light"
            ? "1px solid rgba(255, 255, 255, 0.2)"
            : "1px solid rgba(255, 255, 255, 0.1)",
        animation: "$slideInUp 0.8s cubic-bezier(0.4, 0, 0.2, 1)",
        transition: "all 0.3s ease",

        [theme.breakpoints.down("sm")]: {
            padding: "28px 26px 24px 26px",
            borderRadius: "12px",
        },
    },

    "@keyframes slideInUp": {
        from: {
            opacity: 0,
            transform: "translateY(30px)",
        },
        to: {
            opacity: 1,
            transform: "translateY(0)",
        },
    },

    // Logo (REDUZIDO)
    logoImg: {
        width: "100%",
        maxWidth: "200px",
        height: "auto",
        maxHeight: "55px",
        margin: "0 auto 16px auto",
        filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.1))",
        display: "block",
        content: "url(" + (theme.mode === "light"
            ? theme.calculatedLogoLight()
            : theme.calculatedLogoDark()) + ")",

        [theme.breakpoints.down("sm")]: {
            maxWidth: "180px",
            maxHeight: "50px",
        },
    },
    
    // Container do logo
    logoContainer: {
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginBottom: "4px",
    },

    // Título (REDUZIDO)
    title: {
        color: theme.palette.type === "light" ? "#1e293b !important" : "#f1f5f9 !important",
        fontWeight: 700,
        fontSize: "1.4rem",
        marginBottom: theme.spacing(1.5),
        textAlign: "center",

        [theme.breakpoints.down("sm")]: {
            fontSize: "1.3rem",
            marginBottom: theme.spacing(1),
        },
    },

    // Formulário (SEM MARGEM)
    form: {
        width: "100%",
        marginTop: 0,
    },

    // Campos de input - consistente com Login
    textField: {
        marginBottom: "0px",
        "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
            backgroundColor: theme.palette.type === "light"
                ? "rgba(255, 255, 255, 0.8)"
                : "rgba(30, 30, 30, 0.8)",
            backdropFilter: "blur(10px)",
            transition: "all 0.3s ease",
            "&:hover": {
                backgroundColor: theme.palette.type === "light"
                    ? "rgba(255, 255, 255, 0.9)"
                    : "rgba(30, 30, 30, 0.9)",
            },
            "&.Mui-focused": {
                backgroundColor: theme.palette.type === "light"
                    ? "rgba(255, 255, 255, 1)"
                    : "rgba(30, 30, 30, 1)",
                boxShadow: theme.palette.type === "light"
                    ? "0 0 0 3px rgba(59, 130, 246, 0.1)"
                    : "0 0 0 3px rgba(100, 150, 255, 0.2)",
            },
            "& fieldset": {
                borderColor: theme.palette.type === "light"
                    ? "rgba(59, 130, 246, 0.2)"
                    : "rgba(100, 150, 255, 0.3)",
            },
            "&:hover fieldset": {
                borderColor: theme.palette.type === "light"
                    ? "rgba(59, 130, 246, 0.4)"
                    : "rgba(100, 150, 255, 0.5)",
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.type === "light" ? "#3b82f6" : "#6496ff",
                borderWidth: "2px",
            },
        },
        "& .MuiInputLabel-root": {
            color: theme.palette.type === "light" ? "#1f2937" : "#cbd5e1",
            fontWeight: 600,
            fontSize: "14px",
            "&.Mui-focused": {
                color: theme.palette.type === "light" ? "#3b82f6" : "#6496ff",
            },
        },
        "& .MuiInputBase-input": {
            fontSize: "14px",
            padding: "12px 14px",
            fontWeight: 500,
            "&::placeholder": {
                color: theme.palette.type === "light" ? "#9ca3af" : "#64748b",
                opacity: 1,
            },
        },
    },
    
    // Label customizado acima do campo (COMPACTO)
    fieldLabel: {
        display: "block",
        color: theme.palette.type === "light" ? "#1f2937" : "#f1f5f9",
        fontWeight: 600,
        fontSize: "13px",
        marginBottom: "6px",
        marginTop: "2px",
        textAlign: "left",
        letterSpacing: "0.01em",
    },

    // Botão submit (COMPACTO)
    submit: {
        marginTop: theme.spacing(2.5),
        marginBottom: theme.spacing(1.5),
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        borderRadius: "12px",
        padding: "13px 0",
        fontSize: "15px",
        fontWeight: 600,
        textTransform: "none",
        boxShadow: `0 4px 12px ${theme.palette.primary.main}40`,
        border: "none",
        transition: "all 0.3s ease",
        "&:hover": {
            backgroundColor: theme.palette.primary.dark,
            transform: "translateY(-2px)",
            boxShadow: `0 6px 20px ${theme.palette.primary.main}60`,
        },
        "&:active": {
            transform: "translateY(0)",
        },
        "&:disabled": {
            opacity: 0.6,
        },

        [theme.breakpoints.down("sm")]: {
            padding: "12px 0",
            fontSize: "14px",
        },
    },

    
    // Indicador de etapas
    stepIndicator: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
        marginBottom: theme.spacing(2),
    },
    
    stepDot: {
        width: "10px",
        height: "10px",
        borderRadius: "50%",
        backgroundColor: theme.palette.type === "light" ? "#d1d5db" : "#4b5563",
        transition: "all 0.3s ease",
    },
    
    stepDotActive: {
        width: "32px",
        borderRadius: "5px",
        backgroundColor: theme.palette.primary.main,
    },
    
    // Botões de navegação
    navigationButtons: {
        display: "flex",
        gap: "12px",
        marginTop: theme.spacing(2.5),
        marginBottom: theme.spacing(1.5),
    },
    
    backButton: {
        flex: 1,
        borderRadius: "12px",
        padding: "13px 0",
        fontSize: "15px",
        fontWeight: 600,
        textTransform: "none",
        border: `2px solid ${theme.palette.primary.main}`,
        color: theme.palette.primary.main,
        backgroundColor: "transparent",
        transition: "all 0.3s ease",
        "&:hover": {
            backgroundColor: theme.palette.type === "light" 
                ? "rgba(59, 130, 246, 0.05)" 
                : "rgba(100, 150, 255, 0.05)",
        },
    },
    
    nextButton: {
        flex: 1,
        borderRadius: "12px",
        padding: "13px 0",
        fontSize: "15px",
        fontWeight: 600,
        textTransform: "none",
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        boxShadow: `0 4px 12px ${theme.palette.primary.main}40`,
        transition: "all 0.3s ease",
        "&:hover": {
            backgroundColor: theme.palette.primary.dark,
            transform: "translateY(-2px)",
            boxShadow: `0 6px 20px ${theme.palette.primary.main}60`,
        },
        "&:disabled": {
            opacity: 0.6,
        },
    },

    // Botão de toggle tema
    iconButton: {
        position: "absolute",
        top: 15,
        right: 15,
        background: theme.palette.type === "light"
            ? "rgba(255, 255, 255, 0.1)"
            : "rgba(255, 255, 255, 0.05)",
        backdropFilter: "blur(10px)",
        border: theme.palette.type === "light"
            ? "1px solid rgba(255, 255, 255, 0.2)"
            : "1px solid rgba(255, 255, 255, 0.1)",
        color: theme.palette.type === "light" ? "#374151" : "#e2e8f0",
        transition: "all 0.3s ease",
        zIndex: 10,
        "&:hover": {
            background: theme.palette.type === "light"
                ? "rgba(255, 255, 255, 0.2)"
                : "rgba(255, 255, 255, 0.1)",
            transform: "scale(1.05)",
        },
    },

    // Botão de login (melhorado)
    loginButton: {
        marginTop: theme.spacing(1.5),
        borderRadius: "12px",
        padding: "12px 0",
        fontSize: "14px",
        fontWeight: 600,
        textTransform: "none",
        border: `2px solid ${theme.palette.primary.main}`,
        color: theme.palette.primary.main,
        backgroundColor: "transparent",
        transition: "all 0.3s ease",
        "&:hover": {
            backgroundColor: theme.palette.type === "light" 
                ? "rgba(59, 130, 246, 0.05)" 
                : "rgba(100, 150, 255, 0.05)",
            transform: "translateY(-1px)",
        },
    },
}));

const UserSchema = Yup.object().shape({
    name: Yup.string()
        .min(2, "Too Short!")
        .max(50, "Too Long!")
        .required("Required"),
    companyName: Yup.string()
        .min(2, "Too Short!")
        .max(50, "Too Long!")
        .required("Required"),
    country: Yup.string().required("Required"),
    document: Yup.string()
        .test('document-format', 'Documento inválido', function(value) {
            const { country } = this.parent;
            const countryData = getCountryByCode(country || 'BR');

            // Se documento não é obrigatório para o país, pode estar vazio
            if (!countryData.documentRequired && (!value || value.trim() === '')) {
                return true;
            }

            // Se é obrigatório ou foi preenchido, validar
            if (!value) return false;
            const cleanValue = value.replace(/[^a-zA-Z0-9]/g, '');
            return cleanValue.length >= countryData.minLength && cleanValue.length <= countryData.maxLength;
        })
        .when('country', {
            is: 'BR',
            then: Yup.string().required("CPF ou CNPJ é obrigatório"),
            otherwise: Yup.string()
        }),
    password: Yup.string().min(5, "Too Short!").max(50, "Too Long!"),
    email: Yup.string().email("Invalid email").required("Required"),
    phone: Yup.string().required("Required"),
});

const SignUp = () => {
    const classes = useStyles();
    const theme = useTheme();
    const history = useHistory();
    const { colorMode } = useContext(ColorModeContext);
    const { appLogoFavicon, appName } = colorMode;
    const mode = theme.palette.type;
    const { getPlanList } = usePlans()
    const [plans, setPlans] = useState([])
    const [validatingCnpj, setValidatingCnpj] = useState(false);
    const [lastValidatedDocument, setLastValidatedDocument] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const { getPublicSetting } = useSettings();
    const [backgroundLight, setBackgroundLight] = useState("");
    const [backgroundDark, setBackgroundDark] = useState("");
    const [backgroundColorLight, setBackgroundColorLight] = useState("");
    const [backgroundColorDark, setBackgroundColorDark] = useState("");

    let companyId = null
    const params = qs.parse(window.location.search)
    if (params.companyId !== undefined) {
        companyId = params.companyId
    }

    const initialState = { name: "", email: "", password: "", phone: "", companyId, companyName: "", document: "", planId: "", country: "BR" };

    const [user] = useState(initialState);
    const [selectedCountry, setSelectedCountry] = useState("BR");
    const [currentStep, setCurrentStep] = useState(1); // Controle de etapas

    useEffect(() => {
        getPublicSetting("userCreation")
            .then((data) => {
                if (data === "disabled") {
                    toastUtils.error(i18n.t("signup.toasts.disabled"), "Cadastro Desabilitado");
                    history.push("/login");
                }
            })
            .catch((error) => {
                console.log("Error reading setting", error);
            });

        getPublicSetting("appLogoBackgroundLight", companyId)
            .then((bgLight) => {
                if (bgLight) {
                    setBackgroundLight(getBackendUrl() + "/public/" + bgLight);
                } else {
                    setBackgroundLight("");
                }
            })
            .catch(() => {
                setBackgroundLight("");
            });

        getPublicSetting("appLogoBackgroundDark", companyId)
            .then((bgDark) => {
                if (bgDark) {
                    setBackgroundDark(getBackendUrl() + "/public/" + bgDark);
                } else {
                    setBackgroundDark("");
                }
            })
            .catch(() => {
                setBackgroundDark("");
            });

        getPublicSetting("backgroundColorLight", companyId)
            .then((colorLight) => {
                setBackgroundColorLight(colorLight || "");
            })
            .catch(() => {
                setBackgroundColorLight("");
            });

        getPublicSetting("backgroundColorDark", companyId)
            .then((colorDark) => {
                setBackgroundColorDark(colorDark || "");
            })
            .catch(() => {
                setBackgroundColorDark("");
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            const planList = await getPlanList({ listPublic: "false" });
            setPlans(planList);
        }
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // =========================================================================
    // HANDLERS E FUNÇÕES
    // =========================================================================

    // Função para formatar CPF
    const formatCpf = (value) => {
        const numbers = value.replace(/\D/g, '');
        const limitedNumbers = numbers.slice(0, 11);
        
        if (limitedNumbers.length <= 3) return limitedNumbers;
        if (limitedNumbers.length <= 6) return `${limitedNumbers.slice(0, 3)}.${limitedNumbers.slice(3)}`;
        if (limitedNumbers.length <= 9) return `${limitedNumbers.slice(0, 3)}.${limitedNumbers.slice(3, 6)}.${limitedNumbers.slice(6)}`;
        return `${limitedNumbers.slice(0, 3)}.${limitedNumbers.slice(3, 6)}.${limitedNumbers.slice(6, 9)}-${limitedNumbers.slice(9)}`;
    };

    // Função para formatar CNPJ
    const formatCnpj = (value) => {
        const numbers = value.replace(/\D/g, '');
        const limitedNumbers = numbers.slice(0, 14);
        
        if (limitedNumbers.length <= 2) return limitedNumbers;
        if (limitedNumbers.length <= 5) return `${limitedNumbers.slice(0, 2)}.${limitedNumbers.slice(2)}`;
        if (limitedNumbers.length <= 8) return `${limitedNumbers.slice(0, 2)}.${limitedNumbers.slice(2, 5)}.${limitedNumbers.slice(5)}`;
        if (limitedNumbers.length <= 12) return `${limitedNumbers.slice(0, 2)}.${limitedNumbers.slice(2, 5)}.${limitedNumbers.slice(5, 8)}/${limitedNumbers.slice(8)}`;
        return `${limitedNumbers.slice(0, 2)}.${limitedNumbers.slice(2, 5)}.${limitedNumbers.slice(5, 8)}/${limitedNumbers.slice(8, 12)}-${limitedNumbers.slice(12)}`;
    };

    // Função para formatar documento (CPF ou CNPJ)
    const formatDocument = (value) => {
        const numbers = value.replace(/\D/g, '');
        if (numbers.length <= 11) {
            return formatCpf(value);
        } else {
            return formatCnpj(value);
        }
    };

    const validateDocument = async (document, country, setFieldValue) => {
        const cleanDocument = document.replace(/[^a-zA-Z0-9]/g, '');

        // Evitar validação duplicada
        if (lastValidatedDocument === cleanDocument) {
            return true;
        }

        const countryData = getCountryByCode(country);

        // Se documento não é obrigatório e está vazio, permitir
        if (!countryData.documentRequired && (!document || document.trim() === '')) {
            return true;
        }

        setValidatingCnpj(true);
        try {
            const response = await openApi.post("/auth/validate-cnpj", {
                document: document,
                country: country
            });
            const data = response.data;
            setValidatingCnpj(false);

            if (data.valid && data.data) {
                // Se for CNPJ brasileiro, preencher o nome da empresa
                if (country === 'BR' && data.data.tipo === 'cnpj' && data.data.nome) {
                    setFieldValue('companyName', data.data.nome);
                    toastUtils.success("CNPJ válido! Nome da empresa preenchido automaticamente.", "Empresa Encontrada");
                } else if (country === 'BR' && data.data.tipo === 'cpf') {
                    toastUtils.success("CPF válido!", "Documento Válido");
                } else {
                    toastUtils.success("Documento válido!", "Documento Válido");
                }
                setLastValidatedDocument(cleanDocument);
                return true;
            } else {
                setLastValidatedDocument(cleanDocument);
                toastUtils.error("Documento inválido", "Documento Inválido");
                return false;
            }
        } catch (error) {
            setValidatingCnpj(false);
            console.error("Erro ao validar documento:", error);
            toastUtils.error("Erro ao validar documento. Tente novamente.", "Erro Validação");
            setLastValidatedDocument(cleanDocument);
            return false;
        }
    };

    const handleSignUp = async values => {
        try {
            // Sanitizar dados antes do envio
            const sanitizedValues = {
                ...values,
                document: values.document?.replace(/[^a-zA-Z0-9]/g, '') || '',
                phone: values.phone?.replace(/[^\d+]/g, '') || '', // Apenas + e números
            };

            await openApi.post("/auth/signup", sanitizedValues);
            toastUtils.success(i18n.t("signup.toasts.success"), "Conta Criada");
            history.push("/login");
        } catch (err) {
            toastError(err);
        }
    };

    // Determinar background baseado no tema
    let finalBackground;
    if (mode === "light") {
        if (backgroundLight) {
            finalBackground = `url(${backgroundLight})`;
        } else if (backgroundColorLight) {
            finalBackground = backgroundColorLight;
        } else {
            finalBackground = "linear-gradient(135deg, #1e3a8a 0%, #3b82f6 50%, #60a5fa 100%)";
        }
    } else {
        if (backgroundDark) {
            finalBackground = `url(${backgroundDark})`;
        } else if (backgroundColorDark) {
            finalBackground = backgroundColorDark;
        } else {
            finalBackground = "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%)";
        }
    }

    finalBackground = String(finalBackground || "#f5f5f5");

    return (
        <>
            <Helmet>
                <title>{appName ? `${i18n.t("signup.title")} - ${appName}` : i18n.t("signup.title")}</title>
                <link rel="icon" href={appLogoFavicon || "/favicon.ico"} />
            </Helmet>

            <div
                className={clsx(classes.root, "signup-page")}
                style={{
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '0',
                    margin: '0',
                    boxSizing: 'border-box',
                    overflow: 'hidden',
                    backgroundColor:
                        typeof finalBackground === "string" &&
                        finalBackground.includes("url(")
                            ? "transparent"
                            : finalBackground,
                    backgroundImage:
                        typeof finalBackground === "string" &&
                        finalBackground.includes("url(")
                            ? finalBackground
                            : "none",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <Container
                    component="main"
                    className={classes.containerSignup}
                >
                    <CssBaseline />
                    <div className={classes.paper}>
                        {/* Botão de toggle tema */}
                        <IconButton
                            className={classes.iconButton}
                            onClick={colorMode.toggleColorMode}
                        >
                            {mode === "dark" ? <Brightness7Icon /> : <Brightness4Icon />}
                        </IconButton>

                        {/* Logo */}
                        <div className={classes.logoContainer}>
                            <img className={classes.logoImg} alt="logo" />
                        </div>

                        {/* Título */}
                        <Typography component="h1" variant="h5" className={classes.title}>
                            {i18n.t("signup.title")}
                        </Typography>

                        <Formik
                            initialValues={user}
                            enableReinitialize={true}
                            validationSchema={UserSchema}
                            onSubmit={(values, actions) => {
                                setTimeout(() => {
                                    handleSignUp(values);
                                    actions.setSubmitting(false);
                                }, 400);
                            }}
                        >
                            {({ touched, errors, isSubmitting, setFieldValue, values }) => (
                                <Form className={classes.form}>
                                    {/* Indicador de Etapas */}
                                    <div className={classes.stepIndicator}>
                                        <div className={`${classes.stepDot} ${currentStep === 1 ? classes.stepDotActive : ''}`} />
                                        <div className={`${classes.stepDot} ${currentStep === 2 ? classes.stepDotActive : ''}`} />
                                    </div>
                                    
                                    <Grid container spacing={1}>
                                        {/* ETAPA 1: Dados da Empresa */}
                                        {currentStep === 1 && (
                                            <>
                                        {/* País - Largura total */}
                                        <Grid item xs={12}>
                                            <label className={classes.fieldLabel}>
                                                {i18n.t("signup.form.country")} *
                                            </label>
                                            <FormControl variant="outlined" fullWidth className={classes.textField}>
                                                <Field
                                                    as={Select}
                                                    id="country"
                                                    name="country"
                                                    displayEmpty
                                                    onChange={(e) => {
                                                        setFieldValue('country', e.target.value);
                                                        setSelectedCountry(e.target.value);
                                                        setFieldValue('document', '');
                                                        setLastValidatedDocument('');
                                                    }}
                                                >
                                                    {SUPPORTED_COUNTRIES.map((country) => (
                                                        <MenuItem key={country.code} value={country.code}>
                                                            <span style={{ marginRight: 8 }}>{country.flag}</span>
                                                            {i18n.language === 'en' ? country.nameEn : i18n.language === 'es' ? country.nameEs : country.name}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                            </FormControl>
                                        </Grid>

                                        {/* Documento - Largura total */}
                                        <Grid item xs={12}>
                                            <label className={classes.fieldLabel}>
                                                {(() => {
                                                    const countryData = getCountryByCode(selectedCountry);
                                                    const label = i18n.language === 'en' ? countryData.documentLabelEn :
                                                                  i18n.language === 'es' ? countryData.documentLabelEs :
                                                                  countryData.documentLabel;
                                                    return label + (countryData.documentRequired ? ' *' : ` (${i18n.t("signup.form.optional")})`);
                                                })()}
                                            </label>
                                            <Field
                                                as={TextField}
                                                variant="outlined"
                                                fullWidth
                                                id="document"
                                                name="document"
                                                error={touched.document && Boolean(errors.document)}
                                                helperText={(touched.document && errors.document) || getCountryByCode(selectedCountry).documentPlaceholder}
                                                autoComplete="document"
                                                className={classes.textField}
                                                InputLabelProps={{
                                                    shrink: false,
                                                    style: { display: 'none' }
                                                }}
                                                placeholder={getCountryByCode(selectedCountry).documentPlaceholder}
                                                inputProps={{
                                                    maxLength: 30,
                                                    style: { textTransform: 'none' }
                                                }}
                                                InputProps={{
                                                    endAdornment: validatingCnpj && (
                                                        <CircularProgress size={20} />
                                                    ),
                                                }}
                                                autoFocus
                                                onChange={(e) => {
                                                    let value = e.target.value;
                                                    const countryData = getCountryByCode(selectedCountry);

                                                    const cleanValue = value.replace(/[^a-zA-Z0-9]/g, '');
                                                    if (lastValidatedDocument && lastValidatedDocument !== cleanValue) {
                                                        setLastValidatedDocument("");
                                                    }

                                                    if (selectedCountry === 'BR') {
                                                        const formattedValue = formatDocument(value);
                                                        setFieldValue('document', formattedValue);

                                                        const numbers = value.replace(/\D/g, '');
                                                        if (numbers.length === 11 || numbers.length === 14) {
                                                            validateDocument(formattedValue, selectedCountry, setFieldValue);
                                                        }
                                                    } else {
                                                        setFieldValue('document', value);

                                                        if (cleanValue.length >= countryData.minLength) {
                                                            validateDocument(value, selectedCountry, setFieldValue);
                                                        }
                                                    }
                                                }}
                                            />
                                        </Grid>

                                        {/* Nome da Empresa - Largura total */}
                                        <Grid item xs={12}>
                                            <label className={classes.fieldLabel}>
                                                {i18n.t("signup.form.company")} *
                                            </label>
                                            <Field
                                                as={TextField}
                                                variant="outlined"
                                                fullWidth
                                                id="companyName"
                                                name="companyName"
                                                error={touched.companyName && Boolean(errors.companyName)}
                                                helperText={touched.companyName && errors.companyName}
                                                autoComplete="companyName"
                                                className={classes.textField}
                                                InputLabelProps={{
                                                    shrink: false,
                                                    style: { display: 'none' }
                                                }}
                                                placeholder={i18n.t("signup.form.company")}
                                            />
                                        </Grid>
                                        </>
                                        )}

                                        {/* ETAPA 2: Dados Pessoais */}
                                        {currentStep === 2 && (
                                            <>
                                        {/* Nome - Largura total */}
                                        <Grid item xs={12}>
                                            <label className={classes.fieldLabel}>
                                                {i18n.t("signup.form.name")} *
                                            </label>
                                            <Field
                                                as={TextField}
                                                autoComplete="name"
                                                name="name"
                                                error={touched.name && Boolean(errors.name)}
                                                helperText={touched.name && errors.name}
                                                variant="outlined"
                                                fullWidth
                                                id="name"
                                                className={classes.textField}
                                                InputLabelProps={{
                                                    shrink: false,
                                                    style: { display: 'none' }
                                                }}
                                                placeholder={i18n.t("signup.form.name")}
                                            />
                                        </Grid>

                                        {/* Email - Largura total */}
                                        <Grid item xs={12}>
                                            <label className={classes.fieldLabel}>
                                                {i18n.t("signup.form.email")} *
                                            </label>
                                            <Field
                                                as={TextField}
                                                variant="outlined"
                                                fullWidth
                                                id="email"
                                                name="email"
                                                error={touched.email && Boolean(errors.email)}
                                                helperText={touched.email && errors.email}
                                                autoComplete="email"
                                                className={classes.textField}
                                                InputLabelProps={{
                                                    shrink: false,
                                                    style: { display: 'none' }
                                                }}
                                                placeholder={i18n.t("signup.form.email")}
                                                inputProps={{ style: { textTransform: 'lowercase' } }}
                                            />
                                        </Grid>

                                        {/* Senha - Largura total */}
                                        <Grid item xs={12}>
                                            <label className={classes.fieldLabel}>
                                                {i18n.t("signup.form.password")} *
                                            </label>
                                            <Field
                                                as={TextField}
                                                variant="outlined"
                                                fullWidth
                                                name="password"
                                                error={touched.password && Boolean(errors.password)}
                                                helperText={touched.password && errors.password}
                                                type={showPassword ? "text" : "password"}
                                                id="password"
                                                autoComplete="current-password"
                                                className={classes.textField}
                                                InputLabelProps={{
                                                    shrink: false,
                                                    style: { display: 'none' }
                                                }}
                                                placeholder={i18n.t("signup.form.password")}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                aria-label="toggle password visibility"
                                                                onClick={() => setShowPassword(!showPassword)}
                                                                edge="end"
                                                                style={{ color: "#6b7280" }}
                                                            >
                                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Grid>

                                        {/* Telefone - Largura total */}
                                        <Grid item xs={12}>
                                            <label className={classes.fieldLabel}>
                                                {i18n.t("signup.form.phone")} *
                                            </label>
                                            <Field
                                                as={TextField}
                                                variant="outlined"
                                                fullWidth
                                                id="phone"
                                                name="phone"
                                                autoComplete="phone"
                                                className={classes.textField}
                                                InputLabelProps={{
                                                    shrink: false,
                                                    style: { display: 'none' }
                                                }}
                                                placeholder={i18n.t("signup.form.phone")}
                                            />
                                        </Grid>

                                        {/* Plano - Largura total */}
                                        <Grid item xs={12}>
                                            <label className={classes.fieldLabel}>
                                                Plano *
                                            </label>
                                            <FormControl variant="outlined" fullWidth className={classes.textField}>
                                                <Field
                                                    as={Select}
                                                    variant="outlined"
                                                    fullWidth
                                                    id="plan-selection"
                                                    name="planId"
                                                    required
                                                    displayEmpty
                                                >
                                                    <MenuItem value="" disabled>
                                                        Selecione um plano
                                                    </MenuItem>
                                                    {plans.map((plan, key) => (
                                                        <MenuItem key={key} value={plan.id}>
                                                            <div style={{ 
                                                                display: 'flex', 
                                                                flexDirection: 'column',
                                                                width: '100%',
                                                                gap: '2px'
                                                            }}>
                                                                <div style={{ 
                                                                    fontWeight: 600,
                                                                    fontSize: '14px',
                                                                    color: theme.palette.type === 'light' ? '#1f2937' : '#f1f5f9'
                                                                }}>
                                                                    {plan.name}
                                                                </div>
                                                                <div style={{ 
                                                                    fontSize: '12px',
                                                                    color: theme.palette.type === 'light' ? '#6b7280' : '#9ca3af'
                                                                }}>
                                                                    {plan.users} Atendentes • {plan.connections} WhatsApp • {plan.queues} Filas
                                                                </div>
                                                                <div style={{ 
                                                                    fontSize: '13px',
                                                                    fontWeight: 600,
                                                                    color: theme.palette.primary.main,
                                                                    marginTop: '2px'
                                                                }}>
                                                                    $ {plan.amount}
                                                                </div>
                                                            </div>
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                            </FormControl>
                                        </Grid>
                                        </>
                                        )}
                                    </Grid>

                                    {/* Botões de Navegação */}
                                    <div className={classes.navigationButtons}>
                                        {currentStep === 2 && (
                                            <Button
                                                variant="outlined"
                                                onClick={() => setCurrentStep(1)}
                                                className={classes.backButton}
                                            >
                                                Voltar
                                            </Button>
                                        )}
                                        
                                        {currentStep === 1 ? (
                                            <Button
                                                variant="contained"
                                                onClick={() => {
                                                    // Validar campos da etapa 1
                                                    if (!values.country || !values.companyName) {
                                                        return;
                                                    }
                                                    const countryData = getCountryByCode(values.country);
                                                    if (countryData.documentRequired && !values.document) {
                                                        return;
                                                    }
                                                    setCurrentStep(2);
                                                }}
                                                className={classes.nextButton}
                                                fullWidth={currentStep === 1}
                                                disabled={!values.country || !values.companyName || (getCountryByCode(values.country).documentRequired && !values.document)}
                                            >
                                                Próximo
                                            </Button>
                                        ) : (
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                color="primary"
                                                className={classes.nextButton}
                                                disabled={validatingCnpj}
                                            >
                                                {i18n.t("signup.buttons.submit")}
                                            </Button>
                                        )}
                                    </div>

                                    {/* Botão para login */}
                                    <Button
                                        fullWidth
                                        variant="outlined"
                                        component={RouterLink}
                                        to="/login"
                                        className={classes.loginButton}
                                    >
                                        {i18n.t("signup.buttons.login")}
                                    </Button>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </Container>
            </div>
        </>
    );
};

export default SignUp;